import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import $ from 'jquery';
import { Animated } from 'react-animated-css';

//  ----------------   Form components
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';

//  ----------------   Custom Form components & validations
import { UserName, Email, NewPassword, ConfirmPassword, noSpace, required, minChar8, email, confirmPassword,passwordRegex } from '../formValidation';
import { translate } from 'react-i18next';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faUser,faEnvelope, faLock } from '@fortawesome/fontawesome-free-solid';

import './UserSignUp.css';


class UserSignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      email: '',
      password: '',
      confirmPassword: '',
      fireRedirect: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (value) {
      target.parentElement.classList.add('input--filled');
    } else {
      target.parentElement.classList.remove('input--filled');
    }

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    // get data from all fields in form
    const data = this.form.getValues();

    $.ajax({
      url: '/api/v1/normal/signup',
      type: 'POST',
      data: JSON.stringify(data),
      success: function (res) {
        const msg = res.message;
        this.props.notifySuccess(msg);
        this.props.history.push('/login');
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  render() {
    const { fireRedirect } = this.state;
    return (
      <div>
        <Animated className="form-animation" animationIn="fadeInRight" animationOut="fadeOutLeft" isVisible={true}>

          <Form className="userSignUpForm" ref={c => { this.form = c }} onSubmit={this.handleSubmit}>
            <h2 className="formTitle text-center mt-3">Inscrever-se</h2>
           
          <div className="form-group mt-4">
          {/* <FontAwesomeIcon text-right icon={faUser} /> */}
            <UserName
              required
              id="userName"
              name="userName" 
              maxLength={40}
              autoComplete="off"
              ref={c => { this.UserName = c }}
              value={this.state.userName}
              type="text"
              className="input__field input__field--madoka"
              validations={[required]}
              onChange={this.handleInputChange} />
              
            </div>
              
          
            <div className="form-group">
            {/* <FontAwesomeIcon icon={faEnvelope} /> */}
             <Email
              required
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
              id="email"
              name="email"
              autoComplete="off"
              ref={c => { this.Email = c }}
              value={this.state.email}
              type="email"
              className="input__field input__field--madoka"
              validations={[required, email]}
              onChange={this.handleInputChange}/>
              </div>

            <div className="form-group">
              <NewPassword
                required
                id="password"
                name="password"
                autoComplete="off"
                ref={c => { this.NewPassword = c }}
                value={this.state.password}
                type="password"
                minLength="6"
                className="input__field input__field--madoka"
                onChange={this.handleInputChange}
                validations={[noSpace, required,passwordRegex]}/>
            </div>

            <div className="form-group">
              <ConfirmPassword
                required
                id="confirmPassword"
                name="confirmPassword"
                autoComplete="off"
                ref={c => { this.ConfirmPassword = c }}
                value={this.state.confirmPassword}
                type="password"
                minLength="6"
                className="input__field input__field--madoka"
                onChange={this.handleInputChange}
                validations={[noSpace, required, confirmPassword]}/>
            </div>

            <div className="form-group submitGroup text-center">
              <Button type="submit" className="btn btn--submit mx-auto">Inscrever-se</Button>
            </div>
            {/* code to redirect user to dashboard page after successful login */}
            {fireRedirect && (<Redirect to={'/login'} />)}
          </Form>
        </Animated>
      </div>
    );
  }
}

export default (UserSignUpForm);



// WEBPACK FOOTER //
// ./src/components/UserSignUpForm/UserSignUpForm.js